<template>
  <Entity :entityData="entityData"/>
</template>

<script>
import Entity from '@/components/Entities/Entity';
import { mapState } from 'vuex';

export default {
  props: ['entityId'],
  components: { Entity },
  computed: {
    ...mapState('cmsApiCatalogs', ['illness-kind']),
    entityData() {
      return {
        type: 'illness-kind',
        entitiesString: 'illness-kinds',
        entity: this['illness-kind'].illness_kind,
        details: this['illness-kind'].details,
        entityId: this.entityId,
        texts: {
          getMethod: 'getEntityTexts',
          saveMethod: 'saveEntityTexts',
          entitiesString: 'illnesses_kinds',
          defaultTexts: [
            { text: '', alias: 'txt_short'},
            { text: '', alias: 'txt_long'},
            { text: '', alias: 'txt_ikind_after_3_clinics'},
            { text: '', alias: 'txt_doctors'},
            { text: '', alias: 'medical_analysis'},
            { text: '', alias: 'txt_price'}
          ],
        },
      };
    },
  },
}
</script>
